import React from "react";
import axios from "axios";
import { API_URL } from "../config";
import { errorMessage } from "./message";

const onlyNum = (str: string) => {
    const result = (str.match(/^([0-9\.]+)/) || [''])[0].split('.');
    return result.filter((s: string, i: number) => i < 2).join('.') + result.filter((s:string, i:number) => i>=2).join('');
};

const isDigits = (str: string) => {
    const val = str;
    if(!val.length || val.match(/^([0-9]+)$/)) return (val.match(/^([0-9]+)/) || [''])[0];
    return false;
}

const utoa = (str: string) => {
	return globalThis.btoa(unescape(encodeURIComponent(str)));
}

const atou = (str: string) => {
	return decodeURIComponent(escape(globalThis.atob(str)));
}

const sleep = (t: number) => new Promise((res) => setTimeout(res, t));

const getPrices = async (forceLocal = false, setShowForceUpdating = (f: boolean) => {}) => {
    let clb = (data: any) => {};
    let err = (err: any) => {};

    let prices: any;
    try {
        prices = JSON.parse(localStorage.getItem("prices") || '{}');
        if(!prices.dt) throw new Error("Looks like its the first time. This aint error!");
        setTimeout(() => {
            clb(prices);
        }, 10);
        if(forceLocal) {
            setTimeout(() => {
                clb(prices);
                setShowForceUpdating(false);
            }, 100);
        } else {
            const lastSaveDt = new Date(prices.dt);
            lastSaveDt.setSeconds(lastSaveDt.getSeconds() + 20)
            if(lastSaveDt.getTime() > new Date().getTime()) {
                setTimeout(() => clb(prices), 100);
                forceLocal = true;
                setShowForceUpdating(false);
            }    
        }
    } catch(e) { setShowForceUpdating(false); console.log(e); err(e); }
    if(!forceLocal) {
        setShowForceUpdating(true);
        axios.get(API_URL + 'prices.json').then(res => {
            if(res.data && res.data.success) {
                try {
                    localStorage.setItem("prices", JSON.stringify({...res.data, dt: new Date().toISOString() }));
                } catch(e) {}
                clb(res.data);
            } else throw new Error(res.data || { message: "Error Loading Prices" });
          }).catch(async e => {
            let msg = e.message || 'Oops! There was an error loading latest currency list';
            if(msg.toLowerCase().indexOf("network error") > -1) {
                msg += '! Please check your internet connection';
            }
            errorMessage(msg);
            setShowForceUpdating(false);
            err(e);
          });
    }

    return {
        then: (c: (data: any) => void) => clb = c,
        catch: (c: (e: string) => void) => err = c
    }
}

const formatResultNum = (num: number | string, fractionCount: number) => {
    const result = Number(num).toLocaleString('en', { minimumFractionDigits: fractionCount });
    const fractions = result.split('.')[1];
    if(!fractions) return result;
    if(Number(fractions) === 0) return result.split('.')[0];
    const r = [result.split('.')[0]];
    const fracs = fractions.substring(0, ((f) => { for(let j=f.length-1;j>=0;j--) if(f[j]!=='0') return j + 1; })(fractions));
    if(fracs) r.push(fracs);
    return r.join('.');
}

const depositCurrencyMarket = (depositCurrency: IDepositCurrency, instruments: IInstrument[]) => {
    const idx = instruments.findIndex(ins => {
        return ins.BaseCurrency === depositCurrency.GlobalCurrencyName
    });
    return idx < 0 ? "Forex" : instruments[idx].Market;
}

const stringToId = (str: string): string => {
    return utoa(str).split("=").join("");
}

const genericTranslate = (languageData: any, text: string | undefined) => {
    const prop = text?.toLowerCase().split(" ").join("_") || "";
    if(languageData.hasOwnProperty(prop)) return languageData[prop];
    return text;
}

const getLanguageDirection: (languageData: any) => "ltr" | "rtl" = (languageData: any) => languageData?.__DIRECTION__ || "ltr";

const splitAndRender = (text: string, replacements: any) => {
    const parts = text.split(/(\<br\>|%[A-Z_]+%)/);
    return parts.map((part, index) =>
      part === "<br>" ? (
        <br key={index} />
      ) : replacements[part] ? (
        <React.Fragment key={index}>{replacements[part]}</React.Fragment>
      ) : (
        <React.Fragment key={index}>{part}</React.Fragment>
      )
    );
};

export {
    sleep,
    onlyNum,
    isDigits,
    utoa,
    atou,
    getPrices,
    formatResultNum,
    depositCurrencyMarket,
    stringToId,
    genericTranslate,
    getLanguageDirection,
    splitAndRender
}